export default {
    //葡萄牙语
    DiagnosticReport:'Relatório diagnóstico',
    troubleCode:'Código da falha',
    time:'tempo',
    // 语言
    lang:{
        cn:'Chinês',
        de:'Alemão',
        en:'Inglês',
        es:'Espanhol',
        fr:'Francês',
        it:'Italiano',
        ja:'Japonês',
        ko:'Coreano',
        pt:'Português'
    },
    PositioningPrompt:'Ative o geolocalização para obter preços locais.',
    FaultCode:'código de falha',
    AIDiagnosis:'Diagnóstico por IA',
    AIWait:'Relatório de IA ou aguardando diagnóstico automático',
    FailedFaultCode:'Não foi possível obter informações sobre o código de falha',
    AIError:'Análise de IA falhada',
    more:'mais',
    StoredCodes:'armazenar código',
    PendingCodes:'código pendente',
    PermanentCodes:'codificação permanente',
    Unknown:'desconhecido',
    ManufacturerControl:'controlo do fabricante'
}